// react
import { useContext } from 'react';

// context
import { ContextEntityBeneficiaries } from '../Entity.context';

// mui
import { Container, Grid } from '@mui/material';

// tables
import { TableBeneficiaries } from '../../../tables/cards/TableBeneficiaries/TableBeneficiaries';

export const Beneficiaries = () => {
	// context
	const { isLoadingBeneficiaries, paginationBeneficiaries, beneficiaries, refetchBeneficiaries } =
		useContext(ContextEntityBeneficiaries);

	return (
		<Container maxWidth={false}>
			<Grid container spacing={2}>
				<Grid item xs={12}>
					<TableBeneficiaries
						isLoading={isLoadingBeneficiaries}
						pagination={paginationBeneficiaries}
						beneficiaries={beneficiaries}
						refetchBeneficiaries={refetchBeneficiaries}
					/>
				</Grid>
			</Grid>
		</Container>
	);
};
